import { Card, CardContent } from '@/common/ui/card'
import { Badge } from '@/common/ui/badge'
import { CouponType } from '@/schema'
import { Check, Ticket, Tickets } from 'lucide-react'

interface Step1CouponTypeProps {
	selectedType: CouponType | null
	onSelect: (type: CouponType) => void
	onNext: () => void
}

export default function Step1CouponType({
	selectedType,
	onSelect,
	onNext,
}: Step1CouponTypeProps) {
	const handleSelect = (type: CouponType) => {
		onSelect(type)
		// Auto-advance after a short delay for visual feedback
		setTimeout(() => {
			onNext()
		}, 300)
	}
	return (
		<div className="space-y-6">
			<div className="text-center">
				<h2 className="text-xl font-bold">เลือกประเภทคูปอง</h2>
			</div>

			<div className="grid gap-4 md:grid-cols-2">
				{/* SINGLE Coupon */}
				<Card
					className={`cursor-pointer transition-all hover:shadow-lg ${
						selectedType === CouponType.SINGLE
							? 'border-primary bg-primary/5 ring-2 ring-primary'
							: 'hover:border-primary/50'
					}`}
					onClick={() => handleSelect(CouponType.SINGLE)}
				>
					<CardContent className="p-5">
						<div className="flex items-start justify-between">
							<div className="flex items-center gap-3">
								<div className="rounded-lg bg-blue-500 p-2.5">
									<Ticket className="h-5 w-5 text-white" />
								</div>
								<div>
									<h3 className="text-lg font-bold">คูปองเดี่ยว</h3>
									<Badge variant="outline" className="mt-1 text-xs">
										SINGLE
									</Badge>
								</div>
							</div>
							{selectedType === CouponType.SINGLE && (
								<div className="rounded-full bg-primary p-1">
									<Check className="h-4 w-4 text-white" />
								</div>
							)}
						</div>

						<div className="mt-4 rounded-lg border-2 border-dashed border-blue-300 bg-blue-50 p-3 dark:border-blue-700 dark:bg-blue-950">
							<p className="text-center text-sm font-bold text-blue-700 dark:text-blue-300">
								1 รหัสใช้ได้หลายครั้ง สามารถตั้งรหัสได้ <br />
								(ตัวอย่าง: FREE100)
							</p>
						</div>
					</CardContent>
				</Card>

				{/* MULTIPLE Coupons */}
				<Card
					className={`cursor-pointer transition-all hover:shadow-lg ${
						selectedType === CouponType.MULTIPLE
							? 'border-primary bg-primary/5 ring-2 ring-primary'
							: 'hover:border-primary/50'
					}`}
					onClick={() => handleSelect(CouponType.MULTIPLE)}
				>
					<CardContent className="p-5">
						<div className="flex items-start justify-between">
							<div className="flex items-center gap-3">
								<div className="rounded-lg bg-purple-500 p-2.5">
									<Tickets className="h-5 w-5 text-white" />
								</div>
								<div>
									<h3 className="text-lg font-bold">คูปองหลายใบ</h3>
									<Badge variant="outline" className="mt-1 text-xs">
										MULTIPLE
									</Badge>
								</div>
							</div>
							{selectedType === CouponType.MULTIPLE && (
								<div className="rounded-full bg-primary p-1">
									<Check className="h-4 w-4 text-white" />
								</div>
							)}
						</div>

						<div className="mt-4 rounded-lg border-2 border-dashed border-purple-300 bg-purple-50 p-3 dark:border-purple-700 dark:bg-purple-950">
							<p className="text-center text-sm font-bold text-purple-700 dark:text-purple-300">
								หลายรหัส ใชได้คนละ 1 ครั้ง <br />
								(ตัวอย่าง: EBCE0TY, EBCE1TY, EBCE2TY)
							</p>
						</div>
					</CardContent>
				</Card>
			</div>
		</div>
	)
}
